import * as NPE from 'assets/non-prod-environments.json';
export const NON_PROD_ENVIRONMENTS = NPE;
